// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// vue-router
import router from './router'
// vuex
import Vuex from 'vuex';
import store from '@/vuex/store.js';
// element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.use(Vuex);

// icon file
import './assets/icon/iconfont.css';
// global css file
import './css/global.css';
// custom css file
import './css/custom.css';

// require('./mock');

Vue.config.productionTip = false;

/**
 * 读取./utils下的所有js文件并将export的内容注册到vue原型链
 * 注意：utils文件夹下所有js文件都会被注册到vue.prototype.$文件名  (包括子文件夹)
 * 因此，如果公用js不希望被注册到原型链，放到./js文件夹下
 */
const utilFiles = require.context('./utils', true, /\.js$/);
utilFiles.keys().forEach(fileName => {
  const filename = fileName.replace(/(\.\/|\.js)/g, '');
  Vue.prototype['$' + filename] = utilFiles(fileName).default;
});

// roles用来存放权限数组，也可以用来判断是否登录
// generateRoutes 用来判断是否已经动态加载过了路由
router.beforeEach((to, from, next) => {
  const roles = store.state.userLogin.roles;
  const addroutes = store.state.permission.addRouters;
  if (to.path === '/login') {
    next();
  } else {
    if (roles && roles.length > 0) { // 判断是否有roles(是否登录)
      if (addroutes && addroutes.length > 0) { // 判断是否添加了动态路由
        next();
      } else {
        store.dispatch('GenerateRoutes', { roles }).then(() => { // 生成可访问的路由表
          router.addRoutes(store.state.permission.addRouters); // 动态添加可访问路由表
          next({ ...to, replace: true }); // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
        })
      }
    } else {
      next('/login'); // 否则全部重定向到登录页
    }
  }
});

/* eslint-disable no-new */
var vm = new Vue({
  el: '#app',
  router,
  store, // 使用store
  components: { App },
  template: '<App/>',
  render: h => h(App)
});


// axios
// import API from '@/js/API.js'
// Vue.prototype.$API = API;
// API.setVm(vm)






// WEBPACK FOOTER //
// ./src/main.js